/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {initialQueryState, KTIcon, useDebounce} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {genders} from '../../../../../../constants'
import Select from 'react-select';
import DatePicker from '../../../../../../components/DatePicker'
import api from '../../../../../../utils/Api'
import _ from 'lodash'

const ages = _.range(1, 101).map((i)=>({
  label: `${i} ปี`,
  value: i
}))

const UsersListSearchComponent = ({onSearch = (s: string)=>{}, onFilter = (params: object)=>{}}) => {
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>()
  const [params, setParams] = useState<any>({})
  const [date, setDate] = useState<Date|null>(null)
  const [contypes, setContypes] = useState([])
  // Debounce search term so that it only gives us latest value ...
  // ... if searchTerm has not been updated within last 500ms.
  // The goal is to only have the API call fire when user stops typing ...
  // ... so that we aren't hitting our API rapidly.
  const debouncedSearchTerm = useDebounce(searchTerm, 650)
  // Effect for API call
  useEffect(
    () => {
      if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
        if (!searchTerm || (searchTerm && searchTerm.length > 2)) {
            onSearch(searchTerm)
        }
        //updateState({search: debouncedSearchTerm, ...initialQueryState})
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
    // More details about useDebounce: https://usehooks.com/useDebounce/
  )

  useEffect(()=>{
    api.request('contype', (r)=>{
      setContypes(r.map(({id, nameTh}: any)=>({value: id, label: nameTh})))
    }, {forDropdown: true})
  }, [])

  return (
    <div className="d-flex align-items-center flex-wrap">
      {/* begin::Search */}
      <div className='d-flex align-items-center position-relative my-1'>
        <InputGroup className="d-flex align-items-center">
          <Form.Control
            placeholder="ค้นหา HN, เลขบัตร, ชื่อ, เบอร์"
            className="w-250px"
            onChange={(e)=>setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <InputGroup.Text onClick={()=>{
            setSearchTerm('')
          }} className="cursor-pointer">
            <i className={"fs-2 bi bi-" + (searchTerm?'x':'search')}></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <div style={{width: 180}} className="ms-4">
        <DatePicker
          // selectsRange
          isClearable
          showMonthDropdown
          showYearDropdown
          inputGroupClassName="mb-0"
          name="dateOfBirth"
          placeholderText={"วันที่ออกใบเสร็จ"}
          selected={date}
          dateFormat="dd/MM/yyyy"
          timeCaption="time"
          dropdownMode="select"
          onChange={(d: Date)=>{
            onFilter({...params, treatmentDate: d})
            setDate(d)
          }}
        />
      </div>
      {/* end::Search */}
    </div>
  )
}

export {UsersListSearchComponent}
